import React, { useEffect, useState } from 'react';
import Select from 'react-select';
import axios from 'axios';
import './RequirementManPowerForInterview.css';
import { useNavigate } from "react-router-dom";
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
const RequirementManPowerForInterview = () => {
    const [selectedDate, setSelectedDate] = useState(null);
    const [jobOpenings, setJobOpenings] = useState([]);
    const [basedOnJobId, setBasedOnJobId] = useState({});

    const [jobId, setJobId] = useState(null); // Track selected job ID
    const [selectedExperience, setSelectedExperience] = useState(null);
    const [openings, setOpenings] = useState('');
    const [location, setLocation] = useState('');
    const [reason, setReason] = useState('');
    const [skillSet, setSkills] = useState('');
    const navigate = useNavigate(); // initialize navigation
    const [formErrors, setFormErrors] = useState({});
    const [isJobIdFocused, setIsJobIdFocused] = useState(false);
    const isJobIdLabelFloated = isJobIdFocused || !!jobId;
    const [isExperienceFocused, setIsExperienceFocused] = useState(false);
    const isExperienceLabelFloated = isExperienceFocused || !!selectedExperience;

    // Generate options for 0 to 20 years
    const experienceOptions = Array.from({ length: 21 }, (_, i) => ({
        value: i,  // e.g., 0, 1, 2, ..., 20
        label: `${i} ${i === 1 ? 'year' : 'years'}`  // e.g., '1 year', '2 years', etc.
    }));

    // Fetch all job openings
    const fetchAllJobs = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/job-openings`);
            setJobOpenings(response.data); // Store the response data in state
        } catch (error) {
            console.error("Error fetching job openings:", error);
        }
    };

    // Fetch job details based on the selected job ID
    const fetchJobBasedOnId = async (jobId) => {
        if (!jobId) return; // Don't fetch if jobId is null or undefined
        try {
            const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/job-openings/${jobId}`);
            setBasedOnJobId(response.data); // Set the job details
        } catch (error) {
            console.error("Error fetching job by ID:", error);
        }
    };

    const handleExperienceChange = (selectedOption) => {
        console.log('Selected Experience:', selectedOption);
        setSelectedExperience(selectedOption);
    };

    useEffect(() => {
        fetchAllJobs(); // Fetch all job openings when the component mounts
    }, []);

    useEffect(() => {
        fetchJobBasedOnId(jobId); // Fetch job details when jobId is selected
    }, [jobId]);

    // Handle the change in the job dropdown
    const handleJobChange = (selectedOption) => {
        const jobId = selectedOption ? selectedOption.value : null;
        setJobId(jobId); // update state
        if (jobId) {
            localStorage.setItem('selectedJobId', jobId); // ✅ store in localStorage
        } else {
            localStorage.removeItem('selectedJobId'); // optional: remove if cleared
        }
    };

    useEffect(() => {
        const savedManpowerData = localStorage.getItem("manpowerData");
        if (savedManpowerData) {
            const data = JSON.parse(savedManpowerData);
            setSelectedDate(data.selectedDate);
            setJobId(data.jobId || null);
            setSelectedExperience(
                data.selectedExperience !== null && data.selectedExperience !== undefined
                    ? experienceOptions.find(option => option.value === data.selectedExperience)
                    : null
            );

            setOpenings(data.openings || '');
            setLocation(data.location || '');
            setReason(data.reason || '');
            setSkills(data.skillSet || '');
        }
    }, []);

    const handleSubmit = (e) => {
        e.preventDefault(); // Prevent default form submission

        // Ensure positionName is coming from the fetched job data
        const positionName = basedOnJobId?.positionName || '';

        const formData = {
            selectedDate,
            jobId,
            selectedExperience: selectedExperience ? selectedExperience.value : null,
            openings,
            location,
            reason,
            skillSet,
            positionName,
        };

        localStorage.setItem("manpowerData", JSON.stringify(formData));
        console.log('data:', formData);
        navigate('/portalOrAgency');
    };

    const isFormValid = jobId &&
        openings && parseInt(openings) > 0 &&
        location.trim() &&
        skillSet.trim() &&
        selectedExperience &&
        reason.trim() &&
        selectedDate;


    const name = localStorage.getItem('username');
    const handleNext = () => {
        // You can add validation here if needed
        navigate('/portalOrAgency'); // redirect to next page
    };
    // Fetch all job openings

    return (
        <div className='main-div-man-power'>
            <div className='main-div-man'>
                <h2 className='headding-name'>Request&nbsp;For&nbsp;Man&nbsp;Power</h2>
                <form onSubmit={handleSubmit}>
                    <div className="did-floating-label-content-select">
                        <label className={`did-floating-label-select ${isJobIdLabelFloated ? 'label-float-select' : ''}`}>
                            Job ID
                        </label>
                        <Select
                            placeholder=" "
                            options={jobOpenings.map((job) => ({
                                value: job.jobId,
                                label: job.jobId
                            }))}
                            onChange={handleJobChange}
                            value={
                                jobOpenings.find((job) => job.jobId === jobId)
                                    ? {
                                        value: jobId,
                                        label: jobId
                                    }
                                    : null
                            }
                            onFocus={() => setIsJobIdFocused(true)}
                            onBlur={() => setIsJobIdFocused(false)}
                            classNamePrefix="react-select"
                        />
                    </div>

                    <div className={`man-power ${formErrors.name ? 'did-error-input' : ''}`}>

                        <input
                            type="text" className='man-power-input'
                            placeholder=''
                            value={basedOnJobId?.positionName || ''}
                        />
                        <label className='man-power-label'>Position&nbsp;Name</label>
                    </div>
                    <div className={`man-power ${formErrors.name ? 'did-error-input' : ''}`}>

                        <input type="text" className='man-power-input'
                            // placeholder='Employee Name'
                            value={name}
                        />
                        <label className='man-power-label'>Request&nbsp;By&nbsp;Employee&nbsp;Name</label>
                    </div>
                    {/* <div className='man-power'>
                        
                        <input type="text"
                            // placeholder='Designation'
                            value={designation}
                        />
                        <label><span className='label-text'>Designation:</span></label>
                    </div> */}

                    <div className={`man-power ${formErrors.name ? 'did-error-input' : ''}`}>

                        <input placeholder=' '
                            type="text" className='man-power-input'
                            //   placeholder="No of openings"
                            value={openings}
                            onChange={(e) => {
                                const value = e.target.value;
                                if (/^\d*$/.test(value)) {
                                    setOpenings(value); // only update if input is all digits
                                }
                            }}
                        />
                        <label className='man-power-label'>No.&nbsp;of&nbsp;Openings</label>
                    </div>
                    <div className={`man-power ${formErrors.name ? 'did-error-input' : ''}`}>

                        <input type="text" className='man-power-input'
                            placeholder=''
                            onChange={(e) => setLocation(e.target.value)}
                            value={location}
                        />
                        <label className='man-power-label'>Location</label>
                    </div>
                    <div className={`man-power ${formErrors.name ? 'did-error-input' : ''}`}>

                        <input type="text"
                            placeholder='' className='man-power-input'
                            onChange={(e) => setSkills(e.target.value)}
                            value={skillSet}
                        />
                        <label className='man-power-label'>Skill&nbsp;Set</label>
                    </div>
                    <div className="did-floating-label-content-select">
                        <label className={`did-floating-label-select ${isExperienceLabelFloated ? 'label-float-select' : ''}`}>
                            <span className="label-text-select">Experience</span>
                        </label>
                        <Select
                            placeholder=" "
                            options={experienceOptions}
                            value={selectedExperience}
                            onChange={handleExperienceChange}
                            onFocus={() => setIsExperienceFocused(true)}
                            onBlur={() => setIsExperienceFocused(false)}
                            classNamePrefix="react-select"
                            isClearable
                        />
                    </div>


                    <div className={`man-power ${formErrors.name ? 'did-error-input' : ''}`}>

                        <input type="text"
                            placeholder='' className='man-power-input'
                            onChange={(e) => setReason(e.target.value)}
                            value={reason}
                        />
                        <label className='man-power-label'>Reason</label>
                    </div>
                    <div className={`man-power-datepicker ${formErrors.name ? 'did-error-input' : ''} ${selectedDate ? 'filled' : ''}`}>
                        <DatePicker
                            selected={selectedDate}
                            onChange={(date) => setSelectedDate(date)}
                            dateFormat="dd-MM-yyyy"
                            minDate={new Date()}
                            placeholderText=""
                            className="man-power-input"
                        />
                        <label className="man-power-label">Required&nbsp;by&nbsp;Date</label>
                    </div>
                    <div className="man">
                        <button
                            className='man-power-next'
                            onClick={handleNext}
                            disabled={!isFormValid}  // ✅ Disable until form is valid
                        >
                            Next
                        </button>

                    </div>
                </form>
            </div>
        </div>
    );
};

export default RequirementManPowerForInterview;
